module.exports = __webpack_public_path__ + "static/media/dummy-image.5433efb6.jpg";